import { render, staticRenderFns } from "./vessel-certificate-form.vue?vue&type=template&id=5be7e6c3"
import script from "./vessel-certificate-form.vue?vue&type=script&lang=js"
export * from "./vessel-certificate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports